import React, { useMemo, useEffect } from 'react';
import { MdCheckCircleOutline, MdHighlightOff } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

export default function DistrictBox(props: {
    place: {
        geocoder: any; // Replace with correct type if available from vis.gl
        autocomplete: any; // Replace with correct type if available from vis.gl
    };
}) {
    const { t } = useTranslation();


    // Example: use geocoding library from vis.gl
    const geocodingLib = useMapsLibrary('geocoding');
    const geocoder = useMemo(
        () => geocodingLib && new geocodingLib.Geocoder(),
        [geocodingLib]
    );

    // Replace this with your actual logic using geocoder
    // For now, just a placeholder for supported
    const supported = false;

    useEffect(() => {
        if (!geocoder) return;
        // Example usage:
        // geocoder.geocode({ address: 'Warsaw' }, (results, status) => {
        //   // handle results
        // });
    }, [geocoder]);

    return (
        <div className={'py-2 px-4 shadow'}>
            <div className={'flex flex-row items-center'}>
                <div>
                    <h5>{props.place.autocomplete.structured_formatting?.main_text}</h5>
                    <small>{props.place.autocomplete.structured_formatting?.secondary_text}</small>
                </div>
                <div className={'ml-auto flex items-center gap-2'}>
                    {supported ? (
                        <MdCheckCircleOutline className={'text-xl text-green-600'} />
                    ) : (
                        <MdHighlightOff className={'text-xl text-red-600'} />
                    )}
                    {supported
                        ? t('translation:MAIN_PAGE.COOPERATIVE_DISTRICTS.COOPERATES')
                        : t('translation:MAIN_PAGE.COOPERATIVE_DISTRICTS.NOT_COOPERATES')}
                </div>
            </div>
        </div>
    );
}
